import { Injectable } from '@angular/core';
import { AngularFire } from 'angularfire2';
import { AuthData } from '../providers/auth';
import { Database } from '../providers/database';
import * as firebase from 'firebase';

@Injectable()

export class DiaryData {

  constructor(public af: AngularFire, public auth: AuthData, public db: Database) {
  }

  getListDiary(token_event) {
    return this.af.database.list('/Events/' + token_event + '/Diary/', {
      query: {
        orderByChild: 'date'
      }
    });
  }

  // getListener(tokenEvent: string, component: string) {
  //   return this.af.database.object('/EventListeners/' + tokenEvent + '/' + component)
  // }

  getData(client: any, tokenEvent: string, tokenDiary: string) {
    let dataRef;
    dataRef = firebase.database().ref('/Clients/' + client.url + '/Events/' + tokenEvent + '/Diary/' + tokenDiary)

    return new Promise((resolve, reject) => {
      dataRef.once('value').then((snapshot) => {
        resolve(snapshot.val());
      });
    })
  }

  getSpeakerData(client: any, idSpeaker: string) {
    let dataRef;
    dataRef = firebase.database().ref('/Clients/' + client.url + '/Speakers/' + idSpeaker)

    return new Promise((resolve, reject) => {
      dataRef.once('value').then((snapshot) => {
        resolve(snapshot.val());
      });
    })
  }

  getMyLike(client: any, tokenDiary: string) {
    const q = firebase.database().ref().child('/Clients/' + client.url + '/___likesDiary/' + tokenDiary + '/' + this.auth.getUser().uid);

    return new Promise((resolve, reject) => {
      q.once('value', (snapshot) => {
        resolve(snapshot);
      }).catch((error) => {
        reject(error)
      });
    });
  }

  getLikes(client: any, tokenEvent: string, tokenDiary: string) {
    return this.af.database.object('/Clients/' + client.url + '/Events/' + tokenEvent + '/Diary/' + tokenDiary + '/numLikes');
  }

  getFavorites(client: any) {
    return this.af.database.list('/Clients/' + client.url + '/___favorites/' + this.auth.getUser().uid + '/Diary');
  }

  getComments(client: any, tokenDiary: string) {
    return this.af.database.list('/Clients/' + client.url + '/___commentsDiary/' + tokenDiary);
  }

  getDataConfSpeaker(client: any, tokenEvent:string){
    let dataRef;
    dataRef = firebase.database().ref('/Clients/' + client.url + '/Events/' + tokenEvent + '/SpeakersConfig')
    return new Promise((resolve, reject) => {
      dataRef.once('value').then((snapshot) => {
        resolve(snapshot.val());
      });
    })
  }

  pushLike(client: any, tokenDiary, tokenEvent) {
    let obj = {
      uid: this.auth.getUser().uid,
      email: this.auth.getUser().email || 'Anonymous',
      timestamp: new Date().getTime(),
    };


    return new Promise((resolve, reject) => {
      this.db.pushDatakey('/Clients/' + client.url + '/___likesDiary/' + tokenDiary, obj, this.auth.getUser().uid)
      .then(() => {
        // Increase counter
        firebase.database().ref().child('/Clients/' + client.url + '/Events/' + tokenEvent + '/Diary/' + tokenDiary + '/numLikes').
        transaction(function(currentCount) {
          return currentCount + 1;
        });

        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  pushFavorite(client: any, diaryData: any, tokenEvent) {
    let obj = {
      date: diaryData.date,
      description: diaryData.description,
      end: diaryData.end,
      endEnabled: diaryData.endEnabled,
      id: diaryData.id,
      start: diaryData.start,
      state: diaryData.state,
      title: diaryData.title,
      timestamp: new Date().getTime()
    };

    return new Promise((resolve, reject) => {
      this.db.pushDatakey('/Clients/' + client.url + '/___favorites/' + this.auth.getUser().uid + '/Diary', obj, diaryData.id)
      .then(() => {
        // Increase counter
        firebase.database().ref().child('/Clients/' + client.url + '/Events/' + tokenEvent + '/Diary/' + diaryData.id + '/numFavorites').
        transaction(function(currentCount) {
          return currentCount + 1;
        });

        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  pushComment(client: any, tokenEvent, tokenDiary: string, comment: any) {
    let obj = {
      comment: comment,
      uid: this.auth.getUser().uid,
      email: this.auth.getUser().email || 'Anonymous',
      timestamp: new Date().getTime(),
    };

    return new Promise((resolve, reject) => {
      this.db.pushData('/Clients/' + client.url + '/___commentsDiary/' + tokenDiary, obj)
      .then(() => {
        // Increase counter
        firebase.database().ref().child('/Clients/' + client.url + '/Events/' + tokenEvent + '/Diary/' + tokenDiary + '/numComments').
        transaction(function(currentCount) {
          return currentCount + 1;
        });

        resolve(true);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/diary.ts